import { useCallback, useMemo, useState } from 'react';

export function useModal() {
  const [open, setOpen] = useState<boolean>(false);

  const onClose = useCallback(() => setOpen(false), []);
  const onOpen = useCallback(() => setOpen(true), []);

  const hookData = useMemo(() => ({ open, onClose, onOpen }), [open, onClose, onOpen]);

  return hookData;
}
